
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    // Support both native <details> and the custom <details-accordion>
    this.mainDetailsToggle = this.querySelector('details, details-accordion');
    if (!this.mainDetailsToggle) return;

    this._summary = this.mainDetailsToggle.querySelector('summary');
    // prefer an explicit accordion__content, otherwise fallback to summary.nextElementSibling
    this.content = this.mainDetailsToggle.querySelector('.accordion__content, .mega-menu__content') || (this._summary && this._summary.nextElementSibling);

    // Focusout is attached to the wrapper for both types
    this.addEventListener('focusout', this.onFocusOut.bind(this));

    // Native details emit 'toggle'; for the custom element observe attribute changes on 'open'
    if (this.mainDetailsToggle.tagName.toLowerCase() === 'details') {
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    } else {
      this._attrObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'open') {
            this.onToggle();
          }
        }
      });
      this._attrObserver.observe(this.mainDetailsToggle, { attributes: true });
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;
    if (!this.animations) {
      try {
        this.animations = this.content.getAnimations();
      } catch (e) {
        this.animations = [];
      }
    }

    const isOpen = this.mainDetailsToggle.hasAttribute && this.mainDetailsToggle.hasAttribute('open') || (this.mainDetailsToggle.open === true);
    if (isOpen) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (typeof this.mainDetailsToggle?.syncOpenState === 'function') {
      this.mainDetailsToggle.syncOpenState(false);
    } else {
      this.mainDetailsToggle?.removeAttribute('open');
    }
    this._summary?.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', DetailsDisclosure);
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.bindHoverEvents();
  }

  bindHoverEvents() {
    // Only apply hover behaviour on desktop (pointer: fine)
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (!this._summary) return;

    // Open only when hovering the summary trigger, not the whole header area.
    this._summary.addEventListener('mouseenter', () => {
      clearTimeout(this._closeTimeout);
      if (typeof this.mainDetailsToggle.syncOpenState === 'function') {
        this.mainDetailsToggle.syncOpenState(true);
      } else {
        this.mainDetailsToggle.setAttribute('open', '');
      }
      this._summary.setAttribute('aria-expanded', 'true');
    });

    // Keep menu open while hovering its wrapper/content; cancel pending closes.
    this.addEventListener('mouseenter', () => {
      clearTimeout(this._closeTimeout);
    });

    this.addEventListener('mouseleave', () => {
      this._closeTimeout = setTimeout(() => this.close(), 150);
    });
  }

  onToggle() {
    if (!this.header) return;
    // Support both native details.open and custom details-accordion with 'open' attribute
    const isOpen = (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute && this.mainDetailsToggle.hasAttribute('open')) || (this.mainDetailsToggle && this.mainDetailsToggle.open === true);
    this.header.preventHide = !!isOpen;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);
}
